<template>
    <div>
        <loader v-if="isLoading" />
        <div v-else-if="visible" class="g-mt-5">
            <PayoutCardActivation
                :v-if="!isManaged"
                :payout-account="payoutAccount"
                @refresh-payout-account="handleRefreshPayoutAccount"
            />

            <div class="g-mt-4">
                <PayoutMethod
                    v-if="showPayoutCard"
                    :grin-card="true"
                    :payout-method="payoutCard"
                    :is-default="isDefault(payoutCard.id)"
                    @edit="handleEditPayoutMethod(payoutCard)"
                />

                <PayoutMethod
                    v-for="(method, i) in payoutMethods"
                    :key="i"
                    :payout-method="method"
                    :is-default="isDefault(method.id)"
                    @edit="handleEditPayoutMethod(method)"
                />
            </div>

            <AddPayoutMethod
                class="g-mt-5"
                :is-loading="isLoading"
                :payout-account="payoutAccount"
                :force-open-drawer="forceOpenAddPayoutMethodDrawer"
                @refresh-payout-account="handleRefreshPayoutAccount"
            />

            <EditDebitCardDrawer
                :payout-account="payoutAccount"
                :payout-method="selectedPayoutMethod"
                :visible="isEditDebitCardDrawerOpen"
                @close="hideEditDebitCardDrawer()"
                @refresh-payout-account="handleRefreshPayoutAccount"
            />

            <EditPayoutCardDrawer
                v-if="!isManaged"
                :payout-account="payoutAccount"
                :payout-method="selectedPayoutMethod"
                :visible="isEditPayoutCardDrawerOpen"
                @close="hideEditPayoutCardDrawer()"
                @refresh-payout-account="handleRefreshPayoutAccount"
            />

            <EditBankAccountDrawer
                :payout-account="payoutAccount"
                :payout-method="selectedPayoutMethod"
                :visible="isEditBankAccountDrawerOpen"
                @close="hideEditBankAccountDrawer()"
                @refresh-payout-account="handleRefreshPayoutAccount"
            />
        </div>
    </div>
</template>

<script>
    import useToggle from '../../../../composables/use-toggle';
    import {
        PAYOUT_METHOD_TYPE_CARD,
        PAYOUT_METHOD_ISSUE_TYPE_PHYSICAL,
        PAYOUT_METHOD_TYPE_BANK_MANUAL,
        GRIN_CARD_STATUS_CANCELED
    } from '../../../../../app-v2/constants/payouts';
    import { ref, computed } from 'vue-demi';
    import AddPayoutMethod from './AddPayoutMethod.vue';
    import PayoutMethod from './PayoutMethod.vue';
    import PayoutCardActivation from './PayoutCardActivation.vue';
    import EditDebitCardDrawer from './EditDebitCardDrawer.vue';
    import EditPayoutCardDrawer from './EditPayoutCardDrawer.vue';
    import EditBankAccountDrawer from './EditBankAccountDrawer.vue';
    import useContactStore from '../../../../../stores/contact';
    export default {
        name: 'PayoutMethods',

        props: {
            visible: {
                type: Boolean,
                default: true
            },
            isLoading: {
                type: Boolean,
                default: false
            },
            payoutAccount: {
                type: Object,
                default: null
            },
            forceOpenAddPayoutMethodDrawer: {
                type: Boolean,
                default: false
            }
        },

        components: {
            AddPayoutMethod,
            PayoutMethod,
            PayoutCardActivation,
            EditDebitCardDrawer,
            EditPayoutCardDrawer,
            EditBankAccountDrawer
        },

        setup(props, context) {
            const isManaged = useContactStore().data.is_managed;

            const payoutMethods = computed(() => props.payoutAccount?.external_account?.payout_methods);
            const payoutCard = computed(() => props.payoutAccount?.payout_card);

            const handleRefreshPayoutAccount = (checkStatus = null) => {
                context.emit('refresh-payout-account', checkStatus);
            };

            const isDefault = (payoutMethodId) => {
                return payoutMethodId === props.payoutAccount?.payout_method_id;
            };

            const showPayoutCard = computed(() => {
                return !isManaged && payoutCard.value && payoutCard.value?.status !== GRIN_CARD_STATUS_CANCELED;
            });

            const {
                currentValue: isEditDebitCardDrawerOpen,
                setTrue: showEditDebitCardDrawer,
                setFalse: hideEditDebitCardDrawer
            } = useToggle(false);

            const {
                currentValue: isEditPayoutCardDrawerOpen,
                setTrue: showEditPayoutCardDrawer,
                setFalse: hideEditPayoutCardDrawer
            } = useToggle(false);

            const {
                currentValue: isEditBankAccountDrawerOpen,
                setTrue: showEditBankAccountDrawer,
                setFalse: hideEditBankAccountDrawer
            } = useToggle(false);

            const selectedPayoutMethod = ref(null);

            const handleEditPayoutMethod = (payoutMethod) => {
                selectedPayoutMethod.value = payoutMethod;

                if (payoutMethod?.type === PAYOUT_METHOD_TYPE_CARD && payoutMethod?.issue_type !== PAYOUT_METHOD_ISSUE_TYPE_PHYSICAL) {
                    showEditDebitCardDrawer();
                } else if (payoutMethod?.type === PAYOUT_METHOD_TYPE_CARD && payoutMethod?.issue_type === PAYOUT_METHOD_ISSUE_TYPE_PHYSICAL) {
                    showEditPayoutCardDrawer();
                } else if (payoutMethod?.type === PAYOUT_METHOD_TYPE_BANK_MANUAL) {
                    showEditBankAccountDrawer();
                }
            };

            return {
                handleRefreshPayoutAccount,
                isManaged,
                payoutMethods,
                payoutCard,
                isDefault,
                showPayoutCard,

                isEditDebitCardDrawerOpen,
                hideEditDebitCardDrawer,
                isEditBankAccountDrawerOpen,
                hideEditBankAccountDrawer,
                isEditPayoutCardDrawerOpen,
                hideEditPayoutCardDrawer,
                handleEditPayoutMethod,
                selectedPayoutMethod
            };
        }
    };
</script>
